import { render, staticRenderFns } from "./PrivacyPolicyOtherLanguages.vue?vue&type=template&id=eecf82c6&scoped=true"
import script from "./PrivacyPolicyOtherLanguages.vue?vue&type=script&lang=js"
export * from "./PrivacyPolicyOtherLanguages.vue?vue&type=script&lang=js"
import style0 from "./PrivacyPolicyOtherLanguages.vue?vue&type=style&index=0&id=eecf82c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eecf82c6",
  null
  
)

export default component.exports